@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card [chartHeader]="chartHeader()" [cssClass]="cssClass()" [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters" (onFilterChange)="onDropdownChange()" [testResult]="testResult()"
 >
  <div chart-content [style.height]="'100%'">
    <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [xaxis]="chartOptions.xaxis!"
      [dataLabels]="chartOptions.dataLabels!" [grid]="chartOptions.grid!" [stroke]="chartOptions.stroke!"
      [title]="chartOptions.title!" [yaxis]="chartOptions.yaxis!"></apx-chart>

        <p-table [value]="tableData()" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      @for (
        col of [
          { field: 'group', header: 'LINE_CHART.TABLE.GROUP' },
          { field: 'claims', header: 'LINE_CHART.TABLE.CLAIMS' },
          { field: 'percentage', header: 'LINE_CHART.TABLE.PERCENTAGE' }
        ];
        track col.field
      ) {
        <th>{{ col.header | translate }}</th>
      }
    </tr>

  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      @for (
        col of [
          { field: 'group' },
          { field: 'claims' },
          { field: 'percentage' }
        ];
        track col.field
      ) {
        <td>
          {{
            col.field === 'percentage'
              ? row[col.field].toFixed(2) + '%'
              : row[col.field]
          }}
        </td>
      }
    </tr>
  </ng-template>
</p-table>
  <!--
    <div class="mt-4 text-sm text-gray-700">
      <div style="margin-top: 16px">
        @if (testResults().length > 0) {
        <strong>Mann-Kendall Test Results (Hamed-Rao Modified)</strong><br />
        @for ( result of testResults(); track $index) {
        <strong>Group:</strong> {{ result.group }}<br />
        <strong>Trend:</strong> {{ result.trendValue }}<br />
        <strong>Hypothesis Test (H0: No trend):</strong>
        {{ result.hValue ? 'Reject H0' : 'Fail to Reject H0' }}<br />
        <strong>p-value:</strong> {{ result.pValue.toFixed(2) }}<br />
        <strong>Tau:</strong> {{ result.tauValue.toFixed(2) }}<br /><br />
        }
        } @else {
        <strong>Could not run test</strong>
        }
      </div>
    </div>
    -->
  </div>
</co-chart-card>
}